<template>
	<v-list-item elevation="5" outlined three-line @click="$emit('click')">
		<v-list-item-avatar>
			<v-icon color="secondary">mdi-newspaper-variant-multiple</v-icon>
		</v-list-item-avatar>
		<v-list-item-content>
			<v-list-item-title v-text="title" class="text-wrap" />
			<v-list-item-subtitle style="max-height: 160px" v-html="text" />
		</v-list-item-content>
	</v-list-item>
</template>

<script>
export default {
	props: {
		title: String,
		text: String,
	},
}
</script>

<style lang="scss" scoped>
.newsCard {
	width: 100%;
}

a {
	text-decoration: none;
}
</style>